/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { GoodsReceiptArticleList } from '../../models/goods-receipt-article-list';
import { KeyType } from '../../models/key-type';

export interface PostConsigneeArticlesCompare$Params {
  organizationSiteKey: KeyType;

/**
 * If true, the request is rejected with 409 when it contains duplicate articleOrderNumber + consigneeOrderNumber pairs. Otherwise only the last entry of each pair is processed.
 */
  checkDuplicates?: boolean;
      body: GoodsReceiptArticleList
}

export function postConsigneeArticlesCompare(http: HttpClient, rootUrl: string, params: PostConsigneeArticlesCompare$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, postConsigneeArticlesCompare.PATH, 'post');
  if (params) {
    rb.path('organizationSiteKey', params.organizationSiteKey, {});
    rb.query('checkDuplicates', params.checkDuplicates, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
    })
  );
}

postConsigneeArticlesCompare.PATH = '/organization-sites/{organizationSiteKey}/consignee/articles-compare';
